module.exports = __webpack_public_path__ + "static/media/ArrowDown.58c0d417.svg";